(() => {
  const initialisePurchaseBox = (box) => {
    if (box.dataset.jvanReady === 'true') return;

    const variantsElement = box.querySelector('[data-jvan-variants]');
    const form = box.querySelector('form');
    const variantInput = box.querySelector('[data-jvan-variant-id]');
    const price = box.querySelector('[data-jvan-product-price]');
    const comparePrice = box.querySelector('[data-jvan-product-compare]');
    const savings = box.querySelector('[data-jvan-product-save]');
    const addButton = box.querySelector('[data-jvan-add-button]');
    const addLabel = box.querySelector('[data-jvan-add-label]');
    const availability = box.querySelector('[data-jvan-availability]');
    const quantity = box.querySelector('[data-jvan-quantity]');
    const wishlistButton = box.closest('[data-product-root]')?.querySelector('[data-jvan-wishlist]');
    const delivery = box.querySelector('[data-jvan-delivery]');
    const optionGroups = [...box.querySelectorAll('[data-jvan-option-group]')];

    if (!variantsElement || !form || !variantInput) return;

    let variants;
    try {
      variants = JSON.parse(variantsElement.textContent);
    } catch (error) {
      return;
    }

    const selectedOptions = () => optionGroups.map((group) => group.querySelector('[data-jvan-option-value]:checked')?.value);

    const matchingVariant = (options) => variants.find((variant) => variant.options.every((value, index) => value === options[index]));

    const updateValueAvailability = (options) => {
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-jvan-option-value]').forEach((input) => {
          const candidateOptions = [...options];
          candidateOptions[groupIndex] = input.value;
          const canPurchase = variants.some((variant) => {
            return variant.available && variant.options.every((value, index) => value === candidateOptions[index]);
          });
          input.disabled = !canPurchase;
          input.nextElementSibling?.classList.toggle('is-unavailable', !canPurchase);
        });
      });
    };

    const syncLegacyPicker = (variantId) => {
      const section = box.closest('[data-product-section]') || box.closest('.product--jvan-lightweight');
      const legacySelect = section?.querySelector('.product__info--legacy [data-variant-select]');
      if (!legacySelect || String(legacySelect.value) === String(variantId)) return;
      legacySelect.value = String(variantId);
      legacySelect.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const updateVariant = () => {
      const options = selectedOptions();
      const variant = matchingVariant(options);

      updateValueAvailability(options);

      if (!variant) {
        variantInput.disabled = true;
        addButton.disabled = true;
        addLabel.textContent = 'Unavailable';
        availability.classList.add('is-unavailable');
        availability.lastChild.textContent = ' This combination is unavailable.';
        return;
      }

      variantInput.disabled = !variant.available;
      variantInput.value = variant.id;
      price.textContent = variant.price;
      const hasSavings = Number(variant.comparePriceAmount) > Number(variant.priceAmount);
      if (comparePrice) {
        comparePrice.textContent = variant.comparePrice;
        comparePrice.hidden = !hasSavings;
      }
      if (savings) {
        savings.textContent = `Save ${variant.savings}`;
        savings.hidden = !hasSavings;
      }
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      availability.classList.toggle('is-unavailable', !variant.available);
      availability.lastChild.textContent = variant.available
        ? ' In stock and ready to add to cart.'
        : ' Currently unavailable.';

      quantity.min = variant.quantityMin || 1;
      quantity.step = variant.quantityStep || 1;
      if (variant.quantityMax) quantity.max = variant.quantityMax;
      else quantity.removeAttribute('max');
      if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min;

      syncLegacyPicker(variant.id);
      if (variant.url && window.history?.replaceState) window.history.replaceState({}, '', variant.url);
    };

    box.querySelectorAll('[data-jvan-option-value]').forEach((input) => input.addEventListener('change', updateVariant));

    box.querySelector('[data-jvan-quantity-minus]')?.addEventListener('click', () => {
      quantity.stepDown();
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });

    box.querySelector('[data-jvan-quantity-plus]')?.addEventListener('click', () => {
      quantity.stepUp();
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (wishlistButton) {
      const wishlistKey = 'jvan_wishlist';
      const productHandle = wishlistButton.dataset.productHandle;
      const readWishlist = () => {
        try {
          const items = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
          return Array.isArray(items) ? items : [];
        } catch (error) {
          return [];
        }
      };
      const itemHandle = (item) => typeof item === 'string' ? item : item?.handle;
      const setWishlistState = (active) => {
        wishlistButton.classList.toggle('is-active', active);
        wishlistButton.setAttribute('aria-pressed', String(active));
      };

      setWishlistState(readWishlist().some((item) => itemHandle(item) === productHandle));
      wishlistButton.addEventListener('click', () => {
        const items = readWishlist();
        const active = items.some((item) => itemHandle(item) === productHandle);
        const nextItems = active
          ? items.filter((item) => itemHandle(item) !== productHandle)
          : [...items, productHandle];
        try {
          localStorage.setItem(wishlistKey, JSON.stringify(nextItems));
          setWishlistState(!active);
          window.dispatchEvent(new CustomEvent('jvan:wishlist-change', { detail: { items: nextItems } }));
        } catch (error) {
          setWishlistState(active);
        }
      });
    }

    const pairsTrack = box.querySelector('[data-jvan-pairs-track]');
    if (pairsTrack) {
      const pairsItems = [...pairsTrack.querySelectorAll('[data-jvan-pairs-item]')];
      const pairsDots = [...box.querySelectorAll('[data-jvan-pairs-dot]')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let pairsIndex = 0;

      const setPairsIndex = (nextIndex) => {
        if (!pairsItems.length) return;
        pairsIndex = (nextIndex + pairsItems.length) % pairsItems.length;
        pairsTrack.scrollTo({ left: pairsTrack.clientWidth * pairsIndex, behavior: reducedMotion ? 'auto' : 'smooth' });
        pairsDots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === pairsIndex)));
      };

      box.querySelector('[data-jvan-pairs-previous]')?.addEventListener('click', () => setPairsIndex(pairsIndex - 1));
      box.querySelector('[data-jvan-pairs-next]')?.addEventListener('click', () => setPairsIndex(pairsIndex + 1));
      pairsDots.forEach((dot) => dot.addEventListener('click', () => setPairsIndex(Number(dot.dataset.jvanPairsDot))));

      let pairsScrollFrame;
      pairsTrack.addEventListener('scroll', () => {
        window.cancelAnimationFrame(pairsScrollFrame);
        pairsScrollFrame = window.requestAnimationFrame(() => {
          if (!pairsTrack.clientWidth) return;
          pairsIndex = Math.round(pairsTrack.scrollLeft / pairsTrack.clientWidth);
          pairsDots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === pairsIndex)));
        });
      }, { passive: true });
    }

    if (delivery) {
      const holidayNotice = delivery.querySelector('[data-jvan-holiday-notice]');
      const deliveryEstimate = delivery.querySelector('[data-jvan-delivery-estimate]');
      const holidayStart = Date.parse(delivery.dataset.holidayStart);
      const holidayEnd = Date.parse(delivery.dataset.holidayEnd);
      const isBusinessDay = (date) => date.getDay() !== 0 && date.getDay() !== 6;
      const addBusinessDays = (date, days) => {
        const result = new Date(date);
        let remaining = days;
        while (remaining > 0) {
          result.setDate(result.getDate() + 1);
          if (isBusinessDay(result)) remaining -= 1;
        }
        return result;
      };
      const nextOrderCutoff = (now, cutoffParts) => {
        const cutoff = new Date(now);
        cutoff.setHours(cutoffParts[0] || 0, cutoffParts[1] || 0, cutoffParts[2] || 0, 0);
        if (isBusinessDay(cutoff) && cutoff > now) return cutoff;
        do {
          cutoff.setDate(cutoff.getDate() + 1);
        } while (!isBusinessDay(cutoff));
        return cutoff;
      };
      const dateFormatter = new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        month: 'short',
        day: 'numeric'
      });
      const updateDelivery = () => {
        const now = new Date();
        if (holidayNotice && deliveryEstimate) {
          const holidayActive = now.getTime() >= holidayStart && now.getTime() < holidayEnd;
          holidayNotice.hidden = !holidayActive;
          deliveryEstimate.hidden = holidayActive;
          delivery.classList.toggle('is-holiday', holidayActive);
          if (holidayActive) return;
        }
        const cutoffParts = (delivery.dataset.cutoff || '16:00:00').split(':').map(Number);
        const cutoff = nextOrderCutoff(now, cutoffParts);
        const remainingMinutes = Math.max(0, Math.ceil((cutoff - now) / 60000));
        delivery.querySelector('[data-jvan-delivery-hours]').textContent = String(Math.floor(remainingMinutes / 60)).padStart(2, '0');
        delivery.querySelector('[data-jvan-delivery-minutes]').textContent = String(remainingMinutes % 60).padStart(2, '0');
        delivery.querySelector('[data-jvan-delivery-start]').textContent = dateFormatter.format(addBusinessDays(cutoff, Number(delivery.dataset.deliveryStartDays)));
        delivery.querySelector('[data-jvan-delivery-end]').textContent = dateFormatter.format(addBusinessDays(cutoff, Number(delivery.dataset.deliveryEndDays)));
      };

      updateDelivery();
      window.setInterval(updateDelivery, 60000);
      [holidayStart, holidayEnd].forEach((boundary) => {
        const delay = boundary - Date.now();
        if (delay > 0 && delay <= 2147483647) window.setTimeout(updateDelivery, delay);
      });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) updateDelivery();
      });
    }

    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !document.querySelector('[data-jvan-cart-drawer]')) return;
      event.preventDefault();
      if (addButton.disabled || addButton.getAttribute('aria-busy') === 'true') return;

      const selectedVariant = matchingVariant(selectedOptions());
      const addUrl = new URL(form.action, window.location.origin);
      if (!addUrl.pathname.endsWith('.js')) addUrl.pathname = `${addUrl.pathname.replace(/\/$/, '')}.js`;
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      addLabel.textContent = 'Adding...';

      try {
        const response = await fetch(addUrl.toString(), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: new FormData(form)
        });
        const contentType = response.headers.get('content-type') || '';
        const responseText = await response.text();
        let payload = {};
        if (contentType.includes('application/json')) {
          try {
            payload = JSON.parse(responseText);
          } catch (error) {
            payload = {};
          }
        }
        if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this item.');

        addLabel.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('jvan:cart:open', {
          detail: {
            source: 'product-form',
            variantId: selectedVariant?.id,
            comparePrice: selectedVariant?.comparePrice,
            hasComparePrice: Number(selectedVariant?.comparePriceAmount) > Number(selectedVariant?.priceAmount)
          }
        }));
        window.setTimeout(() => {
          addLabel.textContent = selectedVariant?.available ? 'Add to cart' : 'Sold out';
          addButton.disabled = !selectedVariant?.available;
        }, 900);
      } catch (error) {
        addLabel.textContent = selectedVariant?.available ? 'Add to cart' : 'Sold out';
        addButton.disabled = !selectedVariant?.available;
        availability.classList.add('is-unavailable');
        availability.lastChild.textContent = ` ${error.message || 'Unable to add this item.'}`;
      } finally {
        addButton.removeAttribute('aria-busy');
      }
    });

    box.dataset.jvanReady = 'true';
    updateVariant();
  };

  const initialiseAll = () => document.querySelectorAll('[data-jvan-purchase-box]').forEach(initialisePurchaseBox);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  else initialiseAll();
})();
